module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Size-e9dc556a79bdbd9a6577630e8621b027.svg";